import { AbstractControl } from "@angular/forms";

export function rutValidator(control: AbstractControl): {[key: string]: boolean} | null {
    let rut: AbstractControl = control;
    if(!rut.value) return null;
    // Despejar Puntos
    var valor = rut.value.toString();
   
    valor = valor.split(".").join("");
    
    // Aislar Cuerpo y Dígito Verificador
    let result = valor.split("-");    

    if(result.length > 2) return { "Rut inválido": true };

    let cuerpo = result[0];
    if(isNaN(cuerpo)) return { "Rut inválido": true };  

    let dv = '';
    if(result[1]){
        dv = result[1].toUpperCase();        
    } else return { "Rut inválido": true };  
    
    if (dv.length > 1){
        return { "Rut inválido": true }; 
    }
    // Si no cumple con el mínimo ej. (n.nnn.nnn)
    if(cuerpo.length < 7) { 
        return { "Rut incompleto": true };  
    }
    
    // Calcular Dígito Verificador
    let suma = 0;
    let multiplo = 2;
    
    // Para cada dígito del Cuerpo
    for(let i=1;i<=cuerpo.length;i++) {
        // Obtener su Producto con el Múltiplo Correspondiente
        let index = multiplo * valor.charAt(cuerpo.length - i);
        
        // Sumar al Contador General
        suma = suma + index;
        
        // Consolidar Múltiplo dentro del rango [2,7]
        if(multiplo < 7) { multiplo = multiplo + 1; } else { multiplo = 2; }
    }
    
    // Calcular Dígito Verificador en base al Módulo 11
    let dvEsperado = 11 - (suma % 11);
    let convertedDv = 0;
    // Casos Especiales (0 y K)
    if(dv == 'K')
    {
        convertedDv = 10
    }
    else if(dv == '0')
    {
        convertedDv = 11;
    } else {
        convertedDv = parseInt(dv);
    }
    
    // Validar que el Cuerpo coincide con su Dígito Verificador
    if (dvEsperado != convertedDv) {
        return { "Rut inválido": true };        
      } else {
        return null;
      }    
  };

 export function quitarFormato(legalCode: string) {
    var strRut = legalCode;
    while( strRut.indexOf(".") != -1 ){
        strRut = strRut.replace(".","");
    }
    while( strRut.indexOf("-") != -1 ){
        strRut = strRut.replace("-","");
    }
    return strRut;
}
